:host {
    .ti-tools-snapshot {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        @media only screen and (max-width: 768px) {
            flex-direction: column;
            margin: -8px;
        }

        a {
            text-decoration: none;
            color: $polaris-color-teal5;
        }
        &-fixed {
            display: flex;
            max-width: 470px;
            @media only screen and (max-width: 768px) {
                padding-right: 0;
                width: 100%;
            }
        }
        &-status {
            width: 250px;
            display: flex;
            flex-direction: row-reverse;
            .full-width {
                display: block;
                width: 100%;
                text-align: left;
            }
            div {
                width: 100%;
            }
            ti-button,
            ti-add-to-cart {
                width: 100%;
                white-space: nowrap;
            }
            .ti-tool-snapshot-store-info {
                display: block;
                margin-top: $polaris-space-2;
                white-space: nowrap;
            }
            .ti-tool-snapshot-availability {
                display: flex;
                align-items: baseline;

                & ti-svg-icon {
                    margin-right: $polaris-space-2;
                }
            }
            .ti-tool-snapshot-price {
                display: block;
                margin-top: $polaris-space-2;
                margin-bottom: $polaris-space-2;
                font-weight: $polaris-font-weight-bold;
                white-space: nowrap;
            }
            .ti-opn-search-notify-me-link {
                display: flex;
                ti-svg-icon {
                    margin-right: 4px;
                }
            }

            @media only screen and (max-width: 768px) {
                margin-top: $polaris-space-6;
                width: 100%;
            }
        }
    }
}
